<template>
  <ModalError
    v-model:error="hasError"
    :message="messageError"
    v-show="hasError"
  />
  <ModalSuccess :message="messageSuccess" v-show="isVisibleSuccessMessage" />
  <SpinnerDH v-show="isVisibleSpinner" />

  <router-view />
</template>

<script lang="ts">
import { defineComponent, inject, onErrorCaptured, ref, Ref } from "vue";
import ModalError from "@/components/commons/modals/ModalError.vue";
import { DaccachError } from "@/business/shared/commons/DaccachError";
import { spinnerProcessKey, successProcessKey } from "@/main";
import ModalSuccess from "@/components/commons/modals/ModalSuccess.vue";
import SpinnerDH from "@/components/spinner/SpinnerDH.vue";

export default defineComponent({
  components: {
    SpinnerDH,
    ModalError,
    ModalSuccess,
  },

  setup() {
    const hasError: Ref<boolean> = ref(false);
    const messageError: Ref<string> = ref("");

    const successProcess = inject(successProcessKey)!;
    const { messageSuccess, isVisibleSuccessMessage } = successProcess;

    const spinnerProcess = inject(spinnerProcessKey)!;
    const { isVisibleSpinner } = spinnerProcess;

    onErrorCaptured((err: DaccachError | string) => {
      const finalError = typeof err === "string" ? JSON.parse(err) : err;
      console.error("Error capturado:", finalError);

      try {
        hasError.value = true;
        messageError.value = finalError.error.error;
      } catch (exception) {
        console.error("Error procesando el mensaje de error:", exception);
      }

      return false;
    });

    return {
      hasError,
      messageError,
      messageSuccess,
      isVisibleSuccessMessage,
      isVisibleSpinner,
    };
  },
});
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");

* {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  background-color: #443c11;
  border-radius: 10px;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #f7db45;
  border-radius: 10px;
}
</style>
